import { useEffect, useMemo, useState } from "react";
import { Card, Tabs, Tab } from "react-bootstrap";
import CustomButton from "../../components/CustomButton/CustomButton";
import AddWomenInEnergy from "./AddWomenInEnergy";
import AddWomenLeaders from "./AddWomenLeaders";
import AddEventsGallery from "./AddEventGallery";
import WebService from "../../utility/WebService";
import { toast } from "react-toastify";
import { PencilFill, TrashFill } from "react-bootstrap-icons";
import DeleteModal from "../../components/DeleteModal/DeleteModal";
import HelperService from "../../utility/HelperService";

const WomenInEnergy = () => {
  const [showAddModal, setShowAddModal] = useState(false);
  const [showLeadersModal, setShowLeadersModal] = useState(false);
  const [data, setData] = useState<any>(null);
  const [isLoading, setLoading] = useState(false);

  const [showEventModal, setShowEventModal] = useState(false);
  const [editingEvent, setEditingEvent] = useState<any>(null);
  const [eventMode, setEventMode] = useState<"add" | "edit">("add");

  const [womenLeaders, setWomenLeaders] = useState<any[]>([]);
  const [selectedLeader, setSelectedLeader] = useState<any>(null);
  const [editingLeader, setEditingLeader] = useState<any>(null);
  const [mode, setMode] = useState<"add" | "edit">("add");
  const [pagePermission, setPagePermission] = useState({
    canView: false,
    canAdd: false,
    canEdit: false,
    canDelete: false,
  });
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [leaderIdToDelete, setLeaderIdToDelete] = useState<string | null>(null);

  const [deleteIndex, setDeleteIndex] = useState<number | null>(null);
  const [deleteLeaderIndex, setDeleteLeaderIndex] = useState<number | null>(
    null,
  );
  const [showLeaderDeleteModal, setShowLeaderDeleteModal] = useState(false);
  const [deleteLeaderInfo, setDeleteLeaderInfo] = useState<{
    year: string;
    index: number;
  } | null>(null);

  useEffect(() => {
    getData();
    // getWomenLeaders();
  }, []);

  const handleDeleteLeader = (year: string, index: number) => {
    const updated = { ...data.leaders };

    updated[year] = updated[year].filter((_: any, i: number) => i !== index);

    // remove year key if empty
    if (updated[year].length === 0) {
      delete updated[year];
    }

    const body = new FormData();
    body.append("leaders", JSON.stringify(updated));
    body.append("id", data._id);

    WebService.fileUploadAPI({
      action: `women-in-energy/addLeaders`, // same endpoint
      body,
    }).then(() => {
      toast.success("Women leader deleted successfully");
      getData();
    });
  };

  const getData = () => {
    setLoading(true);
    WebService.getAPI({
      action: `women-in-energy/getContent`,
    })
      .then((res: any) => {
        const perm = res?.data?.permissions || {};
        setPagePermission({
          canView: perm.canView,
          canAdd: perm.canAdd,
          canEdit: perm.canEdit,
          canDelete: perm.canDelete,
        });
        setData(res.data.data);
        setLoading(false);
      })
      .catch(() => {
        setLoading(false);
        // toast.error(err.response?.data?.message || "An error occurred");
      });
  };

  // ----------------- GROUP LEADERS YEAR-WISE (frontend) -----------------
  const groupedLeaders = useMemo(() => {
    const grouped: Record<string, any[]> = {};
    (womenLeaders || []).forEach((leader: any) => {
      const yearKey = leader?.year ? String(leader.year) : "Others";
      if (!grouped[yearKey]) grouped[yearKey] = [];
      grouped[yearKey].push(leader);
    });
    return grouped;
  }, [womenLeaders]);

  const yearKeys = useMemo(
    () => Object.keys(groupedLeaders).sort((a, b) => Number(b) - Number(a)), // descending
    [groupedLeaders],
  );

  const reorderLeaders = (
    yearKey: string,
    fromIndex: number,
    toIndex: number,
  ) => {
    console.log(yearKey, "???");
    if (fromIndex === toIndex) return;

    const updatedLeaders = { ...data.leaders };
    const list = [...updatedLeaders[yearKey]];

    const [moved] = list.splice(fromIndex, 1);
    list.splice(toIndex, 0, moved);

    updatedLeaders[yearKey] = list;

    // 🔹 Update UI immediately
    data.leaders = updatedLeaders;

    // 🔹 Save order to backend
    const body = new FormData();
    body.append("leaders", JSON.stringify(updatedLeaders));
    body.append("id", data._id);

    WebService.fileUploadAPI({
      action: `women-in-energy/addLeaders`,
      body,
    })
      .then(() => {
        // toast.success("Deleted");
        getData();
      })
      .catch(() => {
        toast.error("Failed to update order");
      });
  };

  const reorderEvents = (fromIndex: number, toIndex: number) => {
    if (fromIndex === toIndex) return;

    const updatedEvents = [...data.events];
    const [moved] = updatedEvents.splice(fromIndex, 1);
    updatedEvents.splice(toIndex, 0, moved);

    const body = new FormData();
    body.append("events", JSON.stringify(updatedEvents));
    body.append("id", data._id);

    WebService.fileUploadAPI({
      action: `women-in-energy/addEvents`,
      body,
    })
      .then(() => {
        getData();
      })
      .catch(() => {
        toast.error("Failed to reorder events");
      });
  };

  return (
    <>
      {/* MAIN CONTENT MODAL */}
      <AddWomenInEnergy
        show={showAddModal}
        handleClose={() => {
          setShowAddModal(false);
          getData();
        }}
        data={data}
      />

      {/* WOMEN LEADERS ADD/EDIT MODAL */}
      <AddWomenLeaders
        show={showLeadersModal}
        handleClose={() => {
          setSelectedLeader(null);
          setShowLeadersModal(false);
          //   getWomenLeaders();
          getData();
        }}
        data={data}
        leader={editingLeader}
        mode={mode}
      />

      <AddEventsGallery
        show={showEventModal}
        handleClose={() => {
          setShowEventModal(false);
          getData();
        }}
        data={data}
        event={editingEvent}
        mode={eventMode}
      />

      {/* DELETE CONFIRM MODAL */}
      {/* <DeleteModal
        show={showDeleteModal}
        onHide={() => setShowDeleteModal(false)}
        onDelete={() => {
          if (leaderIdToDelete) {
            WebService.deleteAPI({
              action: `women-leaders/deleteContent/${leaderIdToDelete}`,
            }).then(() => {
              setShowDeleteModal(false);
              //   getWomenLeaders();
            });
          }
        }}
      /> */}

      <div className="events-main">
        <Card className="event-card">
          {/* PAGE HEADER */}
          <div className="d-flex justify-content-between align-items-center">
            <div className="page-title">Women in Energy</div>
          </div>

          {/* MAIN TABS: INFO | WOMEN LEADERS */}
          <Tabs defaultActiveKey="info" className="mt-3">
            {/* ================= INFO TAB ================= */}
            <Tab eventKey="info" title="Info">
              <div className="p-3">
                {isLoading ? (
                  <div
                    className="d-flex justify-content-center align-items-center"
                    style={{ minHeight: 100 }}
                  >
                    <span
                      className="spinner-border"
                      role="status"
                      aria-hidden="true"
                    ></span>
                  </div>
                ) : (
                  <>
                    {/* TOP BUTTONS (same as original, but only here) */}
                    <div className="d-flex justify-content-end mb-3">
                      {pagePermission.canAdd && (
                        <CustomButton
                          isLoading={false}
                          label={data ? "Edit" : "Add"}
                          onClick={() => {
                            setShowAddModal(true);
                          }}
                          style={{ width: 100 }}
                        />
                      )}
                    </div>

                    {data === null ? (
                      <div>No data found</div>
                    ) : (
                      <>
                        {/* Logo */}
                        {data?.logo && (
                          <div className="mb-2 mt-2">
                            <img
                              src={data.logo}
                              alt="Event"
                              style={{
                                objectFit: "contain",
                                width: 300,
                              }}
                              className="border rounded-3 p-2"
                            />
                          </div>
                        )}

                        {/* Title */}
                        {data.title && <strong>Title</strong>}
                        {data?.title && (
                          <div className="mb-2">{data.title}</div>
                        )}

                        {/* Description */}
                        {data?.description && <strong>Description</strong>}
                        {data?.description && (
                          <div className="ql-snow">
                            <div
                              className="mb-2 px-0 ql-editor"
                              dangerouslySetInnerHTML={{
                                __html: HelperService.getPreviewableHTML(data.description),
                              }}
                            />
                          </div>
                        )}

                        {/* Images (carousel images) */}
                        {/* {data.images &&
                          Array.isArray(data.images) &&
                          data.images.length > 0 && (
                            <>
                              <strong>Images</strong>
                              <div className="d-flex flex-wrap gap-3 mb-3">
                                {data.images.map((img: string, i: number) => (
                                  <div
                                    key={i}
                                    className="border rounded p-2"
                                    style={{ width: 220 }}
                                  >
                                    <img
                                      src={img}
                                      alt={`image-${i}`}
                                      style={{
                                        width: "100%",
                                        height: 140,
                                        objectFit: "cover",
                                        borderRadius: 6,
                                      }}
                                    />
                                  </div>
                                ))}
                              </div>
                            </>
                          )} */}
                        {/* Women in Energy (whyWomen) */}
                        {data.womensEnergy &&
                          Array.isArray(data.womensEnergy) &&
                          data.womensEnergy.length > 0 && (
                            <>
                              <strong>Women in Energy</strong>
                              <div className="d-flex flex-wrap gap-3 mb-3 mt-1">
                                {data.womensEnergy.map(
                                  (w: any, idx: number) => (
                                    <div
                                      key={idx}
                                      className="d-flex flex-column align-items-center"
                                    >
                                      <img
                                        src={w.image}
                                        alt={w.title || `w-${idx}`}
                                        style={{
                                          width: 100,
                                          height: 100,
                                          objectFit: "contain",
                                        }}
                                      />
                                      <div className="mt-2 text-center">
                                        <strong>{w.title}</strong>
                                      </div>
                                    </div>
                                  ),
                                )}
                              </div>
                            </>
                          )}

                        {/* Event Highlights (display as cards — improved layout) */}
                        {/* {data.events && Array.isArray(data.events) && data.events.length > 0 && (
                                                    <>
                                                        <strong>Event Highlights</strong>
                                                        <div className="d-flex flex-wrap gap-3 mt-2">
                                                            {data.events.map((ev: any, idx: number) => (
                                                                <div key={idx} className="border rounded p-3 bg-light" style={{ width: 320 }}> */}
                        {/* Thumb: use thumbUrl if present, otherwise image */}
                        {/* {(ev.thumbUrl || ev.image) && (
                                                                        <img
                                                                            src={ev.thumbUrl || ev.image}
                                                                            alt={ev.title || `thumb-${idx}`}
                                                                            style={{ width: "100%", height: 160, objectFit: "cover", borderRadius: 6 }}
                                                                            className="mb-2"
                                                                        />
                                                                    )}

                                                                    {ev.title && <div className="fw-bold mb-1" style={{ fontSize: 15 }}>{ev.title}</div>}
                                                                    {ev.description && <div className="text-muted mb-2" style={{ fontSize: 13, whiteSpace: "pre-wrap" }}>{ev.description}</div>}

                                                                    {ev.videoUrl && (
                                                                        <div className="mb-1">
                                                                            <strong>Video:</strong>{" "}
                                                                            <a href={ev.videoUrl} target="_blank" rel="noreferrer">{ev.videoUrl}</a>
                                                                        </div>
                                                                    )}

                                                                    {ev.link && (
                                                                        <div className="mb-1">
                                                                            <strong>Link:</strong>{" "}
                                                                            <a href={ev.link} target="_blank" rel="noreferrer">{ev.link}</a>
                                                                        </div>
                                                                    )}

                                                                    {ev.publishDate && (
                                                                        <div className="text-muted" style={{ fontSize: 13 }}>
                                                                            <strong>Publish:</strong> {new Date(ev.publishDate).toLocaleDateString()}
                                                                        </div>
                                                                    )}
                                                                </div>
                                                            ))}
                                                        </div>
                                                    </>
                                                )} */}
                      </>
                    )}
                  </>
                )}
              </div>
            </Tab>

            {/* ================= WOMEN LEADERS TAB ================= */}
            <Tab eventKey="leaders" title="Women Leaders">
              <div className="p-3">
                {/* Add Women Leader button */}
                <div className="d-flex justify-content-end mb-3">
                  {pagePermission.canEdit && (
                    <CustomButton
                      isLoading={false}
                      label={"Add Women Leader"}
                      onClick={() => {
                        setMode("add");
                        setEditingLeader(null);
                        setShowLeadersModal(true);
                      }}
                      style={{ width: 180 }}
                    />
                  )}
                </div>

                {/* If no leaders */}
                {(!data?.leaders || Object.keys(data.leaders).length === 0) && (
                  <div>No women leaders found</div>
                )}

                {/* Year-wise tabs from data.leaders */}
                {data?.leaders && Object.keys(data.leaders).length > 0 && (
                  <Tabs
                    className="mt-2"
                    defaultActiveKey={Object.keys(data.leaders)[0]}
                    id="leaders-year-tabs"
                  >
                    {Object.keys(data.leaders)
                      .sort((a, b) => Number(b) - Number(a)) // latest year first
                      .map((yearKey) => (
                        <Tab key={yearKey} eventKey={yearKey} title={yearKey}>
                          <div className="mt-3">
                            <div className="d-flex flex-wrap gap-3 mt-1">
                              {data.leaders[yearKey].map(
                                (woman: any, index: number) => (
                                  <div
                                    key={index}
                                    draggable
                                    onDragStart={(e) => {
                                      e.dataTransfer.setData(
                                        "leaderIndex",
                                        index.toString(),
                                      );
                                    }}
                                    onDragOver={(e) => e.preventDefault()}
                                    onDrop={(e) => {
                                      const fromIndex = Number(
                                        e.dataTransfer.getData("leaderIndex"),
                                      );
                                      reorderLeaders(yearKey, fromIndex, index);
                                    }}
                                    className="mb-2 mt-2 d-flex flex-column align-items-center border rounded p-2"
                                    style={{
                                      width: 160,
                                      cursor: "move",
                                      background: "#fff",
                                    }}
                                  >
                                    {/* 🔹 Drag handle */}
                                    <span
                                      style={{
                                        cursor: "grab",
                                        marginBottom: 6,
                                        color: "#888",
                                      }}
                                      title="Drag to reorder"
                                    >
                                      <svg
                                        width="18"
                                        height="18"
                                        viewBox="0 0 20 20"
                                        fill="currentColor"
                                      >
                                        <circle cx="5" cy="6" r="1.5" />
                                        <circle cx="5" cy="10" r="1.5" />
                                        <circle cx="5" cy="14" r="1.5" />
                                        <circle cx="11" cy="6" r="1.5" />
                                        <circle cx="11" cy="10" r="1.5" />
                                        <circle cx="11" cy="14" r="1.5" />
                                      </svg>
                                    </span>

                                    <img
                                      src={woman.image}
                                      alt={`Woman Leader ${index + 1}`}
                                      style={{
                                        objectFit: "cover",
                                        width: 100,
                                        height: 100,
                                        borderRadius: "50%",
                                      }}
                                    />

                                    <div className="mt-2 text-center">
                                      <strong>{woman.title}</strong>
                                    </div>

                                    <div
                                      className="font-13 text-muted"
                                      style={{
                                        width: "100%",
                                        textAlign: "center",
                                      }}
                                    >
                                      {woman.designation}
                                    </div>

                                    {/* ✨ EDIT + DELETE */}
                                    <div className="mt-2 d-flex gap-2">
                                      <PencilFill
                                        className="cursor-pointer"
                                        onClick={() => {
                                          setMode("edit");
                                          setEditingLeader({
                                            ...woman,
                                            year: yearKey,
                                            index,
                                          });
                                          setShowLeadersModal(true);
                                        }}
                                      />

                                      <TrashFill
                                        color="#DC143C"
                                        className="cursor-pointer"
                                        onClick={() => {
                                          setDeleteLeaderInfo({
                                            year: yearKey,
                                            index,
                                          });
                                          setShowLeaderDeleteModal(true);
                                        }}
                                      />
                                    </div>
                                  </div>
                                ),
                              )}
                            </div>
                          </div>
                        </Tab>
                      ))}
                  </Tabs>
                )}
              </div>
            </Tab>

            <Tab eventKey="events" title="Event Gallery">
              <div className="p-3">
                {/* ADD BUTTON */}
                <div className="d-flex justify-content-end mb-3">
                  {pagePermission.canEdit && (
                    <CustomButton
                      label="Add Event Gallery"
                      isLoading={false}
                      onClick={() => {
                        setEventMode("add");
                        setEditingEvent(null);
                        setShowEventModal(true);
                      }}
                      style={{ width: 200 }}
                    />
                  )}
                </div>

                {/* NO EVENTS */}
                {(!data?.events || data.events.length === 0) && (
                  <div>No event gallery found</div>
                )}

                {/* EVENTS LIST */}
                {data?.events && data.events.length > 0 && (
                  <div className="d-flex flex-wrap gap-3">
                    {data.events.map((event: any, index: number) => (
                      <div
                        key={index}
                        draggable
                        onDragStart={(e) =>
                          e.dataTransfer.setData("eventIndex", index.toString())
                        }
                        onDragOver={(e) => e.preventDefault()}
                        onDrop={(e) => {
                          const fromIndex = Number(
                            e.dataTransfer.getData("eventIndex"),
                          );
                          reorderEvents(fromIndex, index);
                        }}
                        className="border rounded p-3 bg-light"
                        style={{
                          width: 320,
                          cursor: "move",
                          background: "#fff",
                        }}
                      >
                        {/* DRAG HANDLE */}
                        <div
                          style={{
                            cursor: "grab",
                            color: "#888",
                            marginBottom: 6,
                          }}
                          title="Drag to reorder"
                        >
                          ☰
                        </div>

                        {/* IMAGE */}
                        {event.images &&
                          event.images.length > 0 &&
                          event.images[0]?.image && (
                            <img
                              src={event.images[0].image}
                              alt={event.title}
                              style={{
                                width: "100%",
                                height: 140,
                                objectFit: "contain",
                                borderRadius: 6,
                              }}
                              className="mb-2"
                            />
                          )}

                        <strong>{event.title}</strong>
                        <div
                          className="text-muted mt-1"
                          style={{ fontSize: 13 }}
                        >
                          {event.description}
                        </div>

                        {/* ACTIONS */}
                        <div className="d-flex gap-2 mt-2">
                          <PencilFill
                            className="cursor-pointer"
                            onClick={() => {
                              setEventMode("edit");
                              setEditingEvent({ ...event, index });
                              setShowEventModal(true);
                            }}
                          />
                          <TrashFill
                            color="#DC143C"
                            className="cursor-pointer"
                            onClick={() => {
                              setDeleteIndex(index);
                              setShowDeleteModal(true);
                            }}
                          />
                        </div>
                      </div>
                    ))}
                  </div>
                )}
              </div>
            </Tab>
          </Tabs>
        </Card>
        {showDeleteModal && (
          <div
            className="modal fade show d-block"
            style={{ background: "rgba(0,0,0,0.5)" }}
          >
            <div className="modal-dialog modal-dialog-centered">
              <div className="modal-content">
                <div className="modal-header">
                  <h5 className="modal-title">Confirm Delete</h5>
                  <button
                    type="button"
                    className="btn-close"
                    onClick={() => setShowDeleteModal(false)}
                  />
                </div>

                <div className="modal-body">
                  Are you sure you want to delete this event gallery?
                </div>

                <div className="modal-footer">
                  <button
                    className="btn btn-secondary"
                    onClick={() => setShowDeleteModal(false)}
                  >
                    No
                  </button>

                  <button
                    className="btn btn-danger"
                    onClick={() => {
                      if (deleteIndex === null) return;

                      const updated = data.events.filter(
                        (_: any, i: number) => i !== deleteIndex,
                      );

                      const body = new FormData();
                      body.append("events", JSON.stringify(updated));
                      body.append("id", data._id);

                      WebService.fileUploadAPI({
                        action: `women-in-energy/addEvents`,
                        body,
                      }).then(() => {
                        toast.success("Event deleted");
                        setShowDeleteModal(false);
                        setDeleteIndex(null);
                        getData();
                      });
                    }}
                  >
                    Yes, Delete
                  </button>
                </div>
              </div>
            </div>
          </div>
        )}

        {showLeaderDeleteModal && (
          <div
            className="modal fade show d-block"
            style={{ background: "rgba(0,0,0,0.5)" }}
          >
            <div className="modal-dialog modal-dialog-centered">
              <div className="modal-content">
                <div className="modal-header">
                  <h5 className="modal-title">Confirm Delete</h5>
                  <button
                    type="button"
                    className="btn-close"
                    onClick={() => setShowLeaderDeleteModal(false)}
                  />
                </div>

                <div className="modal-body">
                  Are you sure you want to delete this women leader?
                </div>

                <div className="modal-footer">
                  <button
                    className="btn btn-secondary"
                    onClick={() => {
                      setShowLeaderDeleteModal(false);
                      setDeleteLeaderInfo(null);
                    }}
                  >
                    No
                  </button>

                  <button
                    className="btn btn-danger"
                    onClick={() => {
                      if (!deleteLeaderInfo) return;

                      handleDeleteLeader(
                        deleteLeaderInfo.year,
                        deleteLeaderInfo.index,
                      );

                      setShowLeaderDeleteModal(false);
                      setDeleteLeaderInfo(null);
                    }}
                  >
                    Yes, Delete
                  </button>
                </div>
              </div>
            </div>
          </div>
        )}
      </div>
    </>
  );
};

export default WomenInEnergy;
